import { render, staticRenderFns } from "./MedicalNursingsLabel.vue?vue&type=template&id=12c77a2e&scoped=true&lang=pug"
import script from "./MedicalNursingsLabel.vue?vue&type=script&lang=ts"
export * from "./MedicalNursingsLabel.vue?vue&type=script&lang=ts"
import style0 from "./MedicalNursingsLabel.vue?vue&type=style&index=0&id=12c77a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c77a2e",
  null
  
)

export default component.exports